<template>
  <div class="search-operation">
    <div class="el-search vue-top-padding radius">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="el-left">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              :disabled="multipleSelection.length <= 0"
              @click="delBatchOperation"
              >{{ $t("common.delete") }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="20">
          <div class="el-right">
            <el-form
              ref="operation"
              :model="operation"
              :inline="true"
              label-width="10px"
              size="small"
              class="demo-form-inline el-input-height"
            >
              <el-form-item prop="nickName">
                <el-input
                  v-model="operation.nickName"
                  placeholder="Nick name"
                ></el-input>
              </el-form-item>
              <el-form-item prop="userName">
                <el-input
                  v-model="operation.userName"
                  placeholder="User name"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="dateTime"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  :start-placeholder="$t('searchOperation.startTime')"
                  :end-placeholder="$t('searchOperation.endTime')"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSubmit"
                  icon="el-icon-search"
                  >{{ $t("common.search") }}</el-button
                >
                <el-button
                  @click="resetSearch('operation')"
                  icon="el-icon-refresh"
                  >{{ $t("common.reset") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchOperation",
  props: {
    operation: Object,
    operType: Array,
    multipleSelection: Array,
  },
  data() {
    return {
      operationList: [],
      dateTime: "",
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("TimeControl.week"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("TimeControl.month"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("TimeControl.year"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      if (this.dateTime && this.dateTime.length > 0) {
        this.operation.startTime = this.dateTime[0];
        this.operation.endTime = this.dateTime[1];
      }
      this.$emit("onSubmit");
    },

    resetSearch(formName) {
      this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
      this.$toolUtil.clearForm(this.operation);
      this.dateTime = "";
      this.$emit("resetSearch", this.operation);
    },

    // 删除操作日志
    delBatchOperation() {
      this.$confirm(this.$t("searchOperation.isDel"), this.$t("common.tip"), {
        confirmButtonText: this.$t("common.definite"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$api
            .request(this.$url.PrivacyAgreement.delete, this.$method.delete, {
              ids: this.$cloud.getIds(this.multipleSelection),
            })
            .then((res) => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t('log.SearchPrivacyAgree.138273-1'),
                  type: "success",
                });
                this.$emit("update");
              }
            });
        })
        .catch(() => {
          this.$message.info(this.$t('log.SearchPrivacyAgree.138273-2'));
        });
    },
  },
};
</script>

<style></style>
